import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-navigation_pfeil_links",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-navigation_pfeil_rechts",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_7 = { class: "sr-only" }
const _hoisted_8 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clicked'))),
      class: _normalizeClass(["btn", !_ctx.btnOutline ? 'btn-brand1' : 'btn-outline-brand1']),
      disabled: _ctx.btnDisabled
    }, [
      (_ctx.prevM)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.tcRequired ? _ctx.$tc(_ctx.i18nMessage, _ctx.i18nCount) : _ctx.$t(_ctx.i18nMessage)), 1)
          ]))
        : (_ctx.nextM)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _hoisted_6,
              _createTextVNode(),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.tcRequired ? _ctx.$tc(_ctx.i18nMessage, _ctx.i18nCount) : _ctx.$t(_ctx.i18nMessage)), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.tcRequired ? _ctx.$tc(_ctx.i18nMessage, _ctx.i18nCount) : _ctx.$t(_ctx.i18nMessage)), 1))
    ], 10, _hoisted_1)
  ]))
}